import { render, staticRenderFns } from "./DataLoadHelp.vue?vue&type=template&id=d324d5e6&scoped=true"
import script from "./DataLoadHelp.vue?vue&type=script&lang=js"
export * from "./DataLoadHelp.vue?vue&type=script&lang=js"
import style0 from "./DataLoadHelp.vue?vue&type=style&index=0&id=d324d5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d324d5e6",
  null
  
)

export default component.exports